<template>
  <div class="container">


    <el-row :gutter="20">
      <el-col :span="12">

        <div class="topBox">
          <h1>酒店管理</h1>
        </div>

        <el-form :model="restaurantData" ref="ruleFormRef1" :rules="rules1">

          <el-row :gutter="20">
            <el-form-item label="相关图片" prop="WeddingImages">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload1" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">

              <el-form-item label="装修年份" prop="decorationTime">
                <el-select v-model="restaurantData.decorationTime" placeholder="请选择年份">
                  <el-option v-for="year in years" :key="year" :label="year" :value="year">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="最多桌数" prop="tablesNum">
                <el-select v-model="restaurantData.tablesNum" placeholder="请选择">
                  <el-option v-for="num in 100" :key="num" :label="num" :value="num"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row :gutter="20">

            <el-col :span="12">
              <el-form-item label="最低餐标" prop="minimumPriceTable">
                <el-input v-model="restaurantData.minimumPriceTable" type="number"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="停车位" prop="parkingSpaceNum">
                <el-input v-model="restaurantData.parkingSpaceNum" type="number"></el-input>
              </el-form-item>
            </el-col>


          </el-row>

          <el-button type="primary" @click="onClickAddData1(ruleFormRef1)">保存</el-button>
        </el-form>
        <el-divider />
        <div class="topBox" style="margin-top: 20px;">
          <h1>预定管理</h1>
          <el-button type="primary" @click="onClickAddCalendarData()">添加预定</el-button>
        </div>

        <el-row>
          <el-col :span="12">
            <el-config-provider :locale="zhCn">
              <el-calendar>
                <template #date-cell="{ data }">
                  <div @click="handleCalendarChange(data)" style="width: 100%;height: 100%;">
                    <p :class="data.isSelected ? 'is-selected' : ''">
                      {{ data.day.split('-').slice(2).join('-') }}
                    </p>
                    <p v-if="hasReservation(data.day)" class="is-time-check">
                      已预定
                    </p>
                  </div>


                </template>
              </el-calendar>
            </el-config-provider>
          </el-col>
          <el-col :span="12">

            <el-table :data="currentYuDingListData" style="width: 100%" height="400">
              <el-table-column label="预定人名称">
                <template #default="{ row }">
                  <span>{{ row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号">
                <template #default="{ row }">
                  <span>{{ row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template #default="{ row, $index }">
                  <el-button size="small" @click="handleEdit5(row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="handleDelete5($index, row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>


      </el-col>

      <el-col :span="12">

        <div class="topBox">
          <h1>宴会厅管理</h1>
          <el-button type="primary" @click="onClickAddNewData1()">添加宴会厅</el-button>
        </div>

        <el-table :data="tableData" style="width: 100%" height="430">
          <el-table-column prop="imageList" label="图片" width="150">
            <template #default="{ row }">
              <div class="imgBox">
                <img v-if="row.imagesUrl" :src="row.imagesUrl" alt="图片" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nameZh" label="标题" />
          <el-table-column prop="price" label="价格" width="100">
            <template #default="{ row }">
              ¥{{ row.minimumPriceTable }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="200" />

          <el-table-column fixed="right" label="操作" width="100">
            <template #default="{ row }">
              <el-button link type="primary" size="small" @click="handleEdit1(row)">
                编辑
              </el-button>
              <el-button link type="danger" size="small" @click="handleShowDeleteDialog1(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="topBox" style="margin-top: 20px;">
          <h1>套餐管理</h1>
          <el-button type="primary" @click="onClickAddNewData2()">添加套餐</el-button>
        </div>
        <el-table :data="taoCanData" style="width: 100%" height="430">

          <el-table-column prop="nameZh" label="标题" />
          <el-table-column prop="price" label="价格">
            <template #default="{ row }">
              ¥{{ row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="200" />

          <el-table-column fixed="right" label="操作" width="120">
            <template #default="{ row }">
              <el-button link type="primary" size="small" @click="handleEdit2(row)">
                编辑
              </el-button>
              <el-button link type="danger" size="small" @click="handleShowDeleteDialog2(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>


      </el-col>

    </el-row>

    <el-dialog v-model="dialogFormVisible1" title="编辑宴会厅" width="800">
      <el-form :model="currentCarData1" ref="ruleFormRef2" :rules="rules2">

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="宴会厅图片" prop="imagesUrl">
              <div class="avatar-container">
                <div class="avatar-box" v-if="currentCarData1 && currentCarData1.imagesUrl">
                  <el-image class="avatar" :src="currentCarData1.imagesUrl" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage2()" />

                </div>

                <el-upload v-if="!currentCarData1.imagesUrl" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload2" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="维语名称" prop="name">
                  <el-input v-model="currentCarData1.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="中文名称" prop="nameZh">
                  <el-input v-model="currentCarData1.nameZh"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>

          <el-col :span="6">
            <el-form-item label="层高(m)" prop="height">
              <el-input v-model="currentCarData1.height" type="number" min="0"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="最低餐标(元/桌)" prop="minimumPriceTable">
              <el-input v-model="currentCarData1.minimumPriceTable" type="number" min="0"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="餐桌数量" prop="tablesNum">
              <el-select v-model="currentCarData1.tablesNum" placeholder="请选择">
                <el-option v-for="num in 100" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="立柱数量" prop="upright">
              <el-select v-model="currentCarData1.upright" placeholder="请选择">
                <el-option v-for="num in 11" :key="num - 1" :label="num - 1" :value="num - 1"></el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">


          <el-col :span="8">
            <el-form-item label="形状" prop="shape">
              <el-select v-model="currentCarData1.shape" placeholder="请选择宴会厅形状">
                <el-option v-for="item in categoriesXingZhuang" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="面积(平方)" prop="area">
              <el-input v-model="currentCarData1.area" type="number" min="0"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有无LED屏" prop="ledScreen">
              <el-switch v-model="currentCarData1.ledScreen" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch> </el-form-item>
          </el-col>


        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="配套设施" prop="supporting">
              <el-checkbox-group v-model="checkList1">
                <el-checkbox v-for="item in categories1" :key="item.id" :label="item.id" :value="item.id">
                  {{ item.labelZh }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisible1 = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData2(ruleFormRef2)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisible2" title="编辑套餐" width="800">
      <el-form :model="currentCarData2" ref="ruleFormRef3" :rules="rules3">

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="菜谱套餐维语名称" prop="name">
              <el-input v-model="currentCarData2.name"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">

            <el-form-item label="菜谱套餐中文名称" prop="nameZh">
              <el-input v-model="currentCarData2.nameZh"></el-input>
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="价格(元)/桌" prop="price">
              <el-input v-model="currentCarData2.price" type="number" min="0"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="服务费(元)/桌" prop="servicePrice">
              <el-input v-model="currentCarData2.servicePrice" type="number" min="0" placeholder="如果没有请输入0"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row v-if="currentCarData2.id != null">
          <el-col :span="4" :offset="20">
            <el-button size="normal" type="primary" @click="onClickAddNewData3">添加菜品</el-button>
          </el-col>
        </el-row>

        <el-table :data="dishListData" style="width: 100%" height="400" v-if="currentCarData2.id != null">
          <el-table-column label="菜品名称">
            <template #default="{ row }">
              <span>{{ row.nameZh }}</span>
            </template>
          </el-table-column>
          <el-table-column label="菜品类型">
            <template #default="{ row }">
              <span v-if="row.type == 89">热菜</span>
              <span v-else-if="row.type == 90">凉菜</span>
              <span v-else-if="row.type == 91">汤类</span>
              <span v-else-if="row.type == 92">水果</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200">
            <template #default="{ row, $index }">
              <el-button size="small" @click="handleEdit3(row)">编辑</el-button>
              <el-button size="small" type="danger" @click="handleDelete3($index, row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>


      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData3(ruleFormRef3)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="菜品编辑" v-model="dialogFormVisible3" width="350px">
      <el-form :model="currentCarData3" ref="ruleFormRef4" :rules="rules4">


        <el-row :gutter="20">

          <el-col class="dialog-el" :span="24">
            <el-form-item label="菜品名称" prop="name">
              <el-input v-model="currentCarData3.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="菜品类型" prop="type">
              <el-select v-model="currentCarData3.type" placeholder="请选择分类">
                <el-option v-for="item in categories2" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select> </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="dialog-el">
            <div>
              <el-button @click="dialogFormVisible3 = false">取消</el-button>
              <el-button type="primary" @click="onClickAddData4(ruleFormRef4)">确定</el-button>
            </div>
          </el-col>
        </el-row>

      </el-form>
    </el-dialog>


    <el-dialog v-model="dialogVisible" title="提示" width="300">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogCalendarVisible" title="添加预定" width="800">
      <el-form :model="currentYuDingData" ref="ruleFormRef4" :rules="rules5">
        <el-row gutter="20">
          <el-col :span="8">
            <el-form-item label="预定人名称" prop="name">
              <el-input v-model="currentYuDingData.name" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="currentYuDingData.phone" type="number" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预定日期" prop="time">
              <el-config-provider :locale="zhCn">
                <el-date-picker v-model="currentYuDingData.time" type="date" placeholder="选择日期" :size="size" />
              </el-config-provider>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="预定内容" prop="description">
          <el-input v-model="currentYuDingData.description" type="textarea" autocomplete="off" />
        </el-form-item>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogCalendarVisible = false">取消</el-button>
          <el-button type="primary" @click="handleAddCalendar()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

   

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage, ElMessageBox, ElConfigProvider } from 'element-plus'
import { get, post, upload } from '@/api/http';
import { useStore } from 'vuex';
import zhCn from 'element-plus/es/locale/lang/zh-cn'

export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const restaurantData = ref({});
    const tableData = ref([]);
    const imageArray = ref([]);
    const years = ref([]);
    const ruleFormRef1 = ref(null);
    const ruleFormRef2 = ref(null);
    const ruleFormRef3 = ref(null);
    const ruleFormRef4 = ref(null);


    const currentCarData1 = ref({});
    const dialogFormVisible1 = ref(false);
    const dialogFormVisible2 = ref(false);
    const dialogFormVisible3 = ref(false);

    const categories1 = ref([]);
    const categoriesXingZhuang = ref([]);
    const checkList1 = ref([]);
    const taoCanData = ref([]);
    const currentCarData2 = ref({});
    const dishListData = ref([]);
    const currentCarData3 = ref({});
    const categories2 = ref([]);

    const dialogVisible = ref(false);
    const deleteType = ref(0);

    const currentDate = ref(new Date());
    const dialogCalendarVisible = ref(false);
    const currentYuDingListData = ref([]);
    const currentYuDingData = ref({});
    const allCalendarData = ref({});



    const rules1 = reactive({
      WeddingImages: [
        {
          required: true,
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('请选择图片'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],
      decorationTime: [{ required: true, message: '请选择装修年份', trigger: 'change' }],
      tablesNum: [{ required: true, message: '请输入最多桌数', trigger: 'blur' }],
      minimumPriceTable: [{ required: true, message: '请输入最低餐标', trigger: 'blur' }],
      parkingSpaceNum: [{ required: true, message: '请输入停车位数量', trigger: 'blur' }],

    });

    const rules2 = reactive({
      imagesUrl: [
        {
          required: true,
          message: '请选择图片',
          trigger: 'change'
        }
      ],
      name: [{ required: true, message: '请输入', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入', trigger: 'blur' }],
      height: [{ required: true, message: '请输入', trigger: 'blur' }],
      minimumPriceTable: [{ required: true, message: '请输入', trigger: 'blur' }],
      tablesNum: [{ required: true, message: '请选择', trigger: 'change' }],
      upright: [{ required: true, message: '请选择', trigger: 'change' }],
      shape: [{ required: true, message: '请选择', trigger: 'change' }],
      area: [{ required: true, message: '请输入', trigger: 'blur' }],
      shopId: [{ required: true, message: '请输入', trigger: 'blur' }],

      supporting: [
        {
          required: true,
          validator: (rule, value, callback) => {

            if (checkList1.value.length <= 0) {
              callback(new Error('请至少选择一个配套设施'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],

    });

    const rules3 = reactive({
      name: [{ required: true, message: '请输入', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入', trigger: 'blur' }],
      price: [{ required: true, message: '请输入', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      servicePrice: [{ required: true, message: '请输入', trigger: 'blur' }],

    });

    const rules4 = reactive({
      name: [{ required: true, message: '请输入', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入', trigger: 'blur' }],
      type: [{ required: true, message: '请选择', trigger: 'change' }],

    });

    const rules5 = reactive({
      name: [{ required: true, message: '请输入', trigger: 'blur' }],
      phone: [{ required: true, message: '请输入', trigger: 'blur' }],
      description: [{ required: true, message: '请输入', trigger: 'blur' }],
      time: [{ required: true, message: '请选择', trigger: 'change' }],
    });


    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });


    onMounted(() => {
      getData();
      getTableData();
      getTaoCanData();
      getCategoryData();
      generateYears();
      getAllCalendarData();
    });


    const generateYears = () => {
      const currentYear = new Date().getFullYear();
      for (let year = 2010; year <= currentYear; year++) {
        years.value.push(year);
      }
    }

    const getData = async () => {
      try {
        const response = await get('adminWeddingRestaurant/shopRestaurant', { "id": shopId.value })
        if (response.code === 200) {
          restaurantData.value = response.data;
          imageArray.value = response.data.imageList;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }



    const addData = async () => {

      const dataParam = {
        'decorationTime': restaurantData.value.decorationTime,
        'tablesNum': restaurantData.value.tablesNum,
        'minimumPriceTable': restaurantData.value.minimumPriceTable,
        'parkingSpaceNum': restaurantData.value.parkingSpaceNum,
        'imagesId': restaurantData.value.imagesId,
        'shopId': shopId.value,
        'status': restaurantData.value.status,
      };

      if (restaurantData.value.id) {
        dataParam.id = restaurantData.value.id;
      }

      try {
        const response = await post('adminWeddingRestaurant/addRestaurant', dataParam)
        if (response.code === 200) {
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }

    }

    const addBanquetHallData = async () => {

      var supportingFacilities = checkList1.value.join(',');


      const dataParam = {
        'name': currentCarData1.value.name,
        'nameZh': currentCarData1.value.nameZh,
        'height': currentCarData1.value.height,
        'minimumPriceTable': currentCarData1.value.minimumPriceTable,
        'tablesNum': currentCarData1.value.tablesNum,
        'upright': currentCarData1.value.upright,
        'shape': currentCarData1.value.shape,
        'area': currentCarData1.value.area,
        'ledScreen': currentCarData1.value.ledScreen,
        'supportingFacilities': supportingFacilities,
        'imagesId': currentCarData1.value.imagesId,
        'imagesUrl': currentCarData1.value.imagesUrl,
        'shopId': shopId.value,
        'status': currentCarData1.value.status,
      };

      if (currentCarData1.value.id) {
        dataParam.id = currentCarData1.value.id;
      }

      try {
        const response = await post('adminWeddingBanquetHall/addBanquetHall', dataParam)
        if (response.code === 200) {
          ElMessage.success("保存成功");
          dialogFormVisible1.value = false;
          getTableData();
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }

    }


    const addMenuData = async () => {

      const dataParam = {
        'name': currentCarData2.value.name,
        'nameZh': currentCarData2.value.nameZh,
        'price': currentCarData2.value.price,
        'servicePrice': currentCarData2.value.servicePrice,
        'shopId': shopId.value,
        'status': currentCarData2.value.status,
      };

      if (currentCarData2.value.id) {
        dataParam.id = currentCarData2.value.id;
      }

      try {
        const response = await post('adminWeddingRestaurantMenu/addMenu', dataParam)
        if (response.code === 200) {
          ElMessage.success("保存成功");
          dialogFormVisible2.value = false;
          getTaoCanData();
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }

    }



    const addDishData = async () => {

      const dataParam = {
        'name': currentCarData3.value.name,
        'nameZh': currentCarData3.value.nameZh,
        'type': currentCarData3.value.type,
        'menuId': currentCarData2.value.id,
      };

      if (currentCarData3.value.id) {
        dataParam.id = currentCarData3.value.id;
      }

      try {
        const response = await post('adminWeddingDish/addDish', dataParam)
        if (response.code === 200) {
          ElMessage.success("保存成功");
          dialogFormVisible3.value = false;
          getDishData(currentCarData2.value.id);
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }

    }



    const uploadFile = async (file, type) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {

            if (type == 1) {
              imageArray.value.push(response.data);
              restaurantData.value.imagesId = imageArray.value.map(item => item.id).join(',');
            } else if (type == 2) {
              currentCarData1.value.imagesId = response.data.id;
              currentCarData1.value.imagesUrl = response.data.url;
            }


          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const getTableData = async () => {
      try {
        const response = await get('adminWeddingBanquetHall/allShopBanquetHall', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const getTaoCanData = async () => {
      try {
        const response = await get('adminWeddingRestaurantMenu/allShopMenu', { "shopId": shopId.value })
        if (response.code === 200) {
          taoCanData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const getCategoryData = async () => {
      try {
        const response = await get('adminCategories/getCategoriesByParentId/12')
        if (response.code === 200) {

          categories1.value = response.data[0].children;
          categories2.value = response.data[1].children;
          categoriesXingZhuang.value = response.data[2].children;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }


    const getDishData = async (menuId) => {
      try {
        const response = await get(`adminWeddingDish/allDish/${menuId}`)
        if (response.code === 200) {

          dishListData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }


    const beforeUpload1 = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file, 1);
      return false; // 阻止默认上传行为
    }


    const beforeUpload2 = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file, 2);
      return false; // 阻止默认上传行为
    }


    const deleteBanquethalData = async (id) => {
      await get('adminWeddingBanquetHall/deleteBanquetHall/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const deleteMenuData = async (id) => {
      await get('adminWeddingRestaurantMenu/deleteMenu/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const getAllCalendarData = async () => {

      try {
        const response = await get('adminRestaurantCalendar/all', { 'id': shopId.value });
        if (response.code === 200) {
          const obj = {};
          response.data.forEach(item => {
            const dateKey = formatDate(item.time);
            if (!obj[dateKey]) {
              obj[dateKey] = [];
            }
            obj[dateKey].push(item);
          });
          allCalendarData.value = obj;
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }
    }

    const addCalendarData = async () => {

      const formattedTime = new Date(currentYuDingData.value.time).toLocaleDateString('zh-CN').replace(/\//g, '-');
      const formatEndTime = formatDate(formattedTime);

      const dataParam = {
        'name': currentYuDingData.value.name,
        'phone': currentYuDingData.value.phone,
        'time': formatEndTime,
        'description': currentYuDingData.value.description,
        'shopId': shopId.value,
        'status': currentYuDingData.value.status,
      };

      if (currentYuDingData.value.id) {
        dataParam.id = currentYuDingData.value.id;
      }

      try {
        const response = await post('adminRestaurantCalendar/add', dataParam)
        if (response.code === 200) {
          ElMessage.success("保存成功");
          dialogCalendarVisible.value = false;
          getAllCalendarData();
        } else {
          ElMessage.error(response.msg);
        }
      } catch (error) {
        console.error('请求失败', error);
        ElMessage.error('请求失败，请重试');
      }

    }


    const onClickAddData1 = async (formEl) => {

      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }


    const onClickAddData2 = async (formEl) => {

      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addBanquetHallData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const onClickAddData3 = async (formEl) => {

      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addMenuData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const onClickAddData4 = async (formEl) => {

      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addDishData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const handleDelete3 = async (index, item) => {

      ElMessageBox.confirm('确定删除该项么?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(async () => {
          try {
            const response = await get(`adminWeddingDish/deleteDish/${item.id}`)
            if (response.code === 200) {

              ElMessage.success('删除成功');
              dishListData.value.splice(index, 1);

            } else {
              ElMessage.error(response.msg)
            }
          } catch (error) {
            console.error('请求失败', error)
            ElMessage.error('请求失败，请重试')
          }
        })
        .catch(() => {

        })

    }


    const handleDelete5 = async (index, item) => {

      ElMessageBox.confirm('确定删除该项么?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(async () => {
          try {
            const response = await get(`adminRestaurantCalendar/delete/${item.id}`)
            if (response.code === 200) {

              ElMessage.success('删除成功');
              currentYuDingListData.value.splice(index, 1);

            } else {
              ElMessage.error(response.msg)
            }
          } catch (error) {
            console.error('请求失败', error)
            ElMessage.error('请求失败，请重试')
          }
        })
        .catch(() => {

        })

    }


    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        restaurantData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }


    const removeImage2 = () => {
      if (currentCarData1.value.imagesId) {
        deleteData(currentCarData1.value.imagesId);
        currentCarData1.value.imagesUrl = null;
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }


    const handleEdit1 = (item) => {

      currentCarData1.value = item;
      if (item.supportingFacilities != null) {
        checkList1.value = item.supportingFacilities.split(',').map(Number);
      }
      dialogFormVisible1.value = true;

    };

    const handleEdit2 = (item) => {

      getDishData(item.id);
      currentCarData2.value = item;
      dialogFormVisible2.value = true;

    };

    const handleEdit3 = (item) => {

      currentCarData3.value = item;
      dialogFormVisible3.value = true;

    };


    const onClickAddNewData1 = () => {

      currentCarData1.value = {};
      checkList1.value = [];
      dialogFormVisible1.value = true;

    }

    const onClickAddNewData2 = () => {

      currentCarData2.value = {};
      dialogFormVisible2.value = true;

    }

    const onClickAddNewData3 = () => {

      currentCarData3.value = {};
      dialogFormVisible3.value = true;

    }

    const handleShowDeleteDialog1 = (row) => {
      currentCarData1.value = row;
      deleteType.value = 1;
      dialogVisible.value = true;
    }

    const handleShowDeleteDialog2 = (row) => {
      currentCarData2.value = row;
      deleteType.value = 2;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      if (deleteType.value == 1 && currentCarData1.value != null) {
        deleteBanquethalData(currentCarData1.value.id);
      } else if (deleteType.value == 2 && currentCarData2.value != null) {
        deleteMenuData(currentCarData2.value.id);
      }
    }

    // 检查某天是否有预定
    const hasReservation = (date) => {
      return allCalendarData.value[date];
    }

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 0-11 → 1-12
      const day = date.getDate();

      // 统一为 YYYY-MM-DD 格式（月份和日期补零）
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    };

    const handleEdit5 = (data) => {
      currentYuDingData.value = data;
      dialogCalendarVisible.value = true;

    }

    const handleCalendarChange = (dateData) => {
      const dateKey = formatDate(dateData.day);
      const reservations = allCalendarData.value[dateKey];
      if (reservations && reservations.length > 0) {
        currentYuDingListData.value = reservations;
      } else {
        currentYuDingListData.value = [];
      }
    }

    const onClickAddCalendarData = () => {
      currentYuDingData.value = {};
      dialogCalendarVisible.value = true;
    };

    const handleAddCalendar = () => {
      addCalendarData();
    };

    return {
      restaurantData,
      imageArray,
      years,
      rules1,
      ruleFormRef1,
      onClickAddData1,
      removeImage1,
      beforeUpload1,
      tableData,
      currentCarData1,
      dialogFormVisible1,
      categories1,
      rules2,
      ruleFormRef2,
      handleEdit1,
      removeImage2,
      beforeUpload2,
      checkList1,
      onClickAddData2,
      onClickAddNewData1,
      onClickAddNewData2,
      taoCanData,
      dialogFormVisible2,
      ruleFormRef3,
      rules3,
      onClickAddData3,
      currentCarData2,
      handleEdit2,
      dishListData,
      handleEdit3,
      handleDelete3,
      dialogFormVisible3,
      currentCarData3,
      ruleFormRef4,
      rules4,
      categories2,
      onClickAddData4,
      onClickAddNewData3,
      dialogVisible,
      handleShowDeleteDialog1,
      handleShowDeleteDialog2,
      handleDelete,
      deleteType,
      ElConfigProvider,
      zhCn,
      currentDate,
      handleCalendarChange,
      dialogCalendarVisible,
      onClickAddCalendarData,
      handleAddCalendar,
      currentYuDingData,
      currentYuDingListData,
      rules5,
      allCalendarData,
      hasReservation,
      handleEdit5,
      handleDelete5,
      categoriesXingZhuang,
    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}

.is-selected {
  color: #1989fa;
}

.is-time-check {
  color: green;
}
</style>
